import { render, staticRenderFns } from "./KVKKContent.vue?vue&type=template&id=d989b6ae&scoped=true&"
import script from "./KVKKContent.vue?vue&type=script&lang=js&"
export * from "./KVKKContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d989b6ae",
  null
  
)

export default component.exports